<div class="is-relative">
    <form [formGroup]="form" class="content-type-form" isavFieldIndex>
        <isav-field-index></isav-field-index>
        <isav-text-input
            label="1. Full Name Of Data Set"
            formControlName="fullNameOfDataSet"
            [mandatory]="true"
            tooltipKey="Datalink:fullNameOfDataSet"
        ></isav-text-input>
        <isav-text-input
            label="2. Subtitle"
            formControlName="subtitle"
            tooltipKey="Datalink:subtitle"
        ></isav-text-input>
        <isav-image-form
            label="3. Image"
            formControlName="image"
            tooltipKey="Datalink:image"
            property="image"
            [contentIri]="value['@id']"
        ></isav-image-form>
        <isav-text-input
            label="4. Acronym"
            formControlName="acronym"
            tooltipKey="Datalink:acronym"
        ></isav-text-input>
        <isav-link-input
            label="5. Link To Data Access Page"
            formControlName="linkToDataAccessPage"
            [mandatory]="true"
            tooltipKey="Datalink:linkToDataAccessPage"
        ></isav-link-input>
        <isav-taxonomy-select-input
            label="6. Organisation"
            formControlName="organisation"
            taxonomy="Organisation"
            [mandatory]="true"
            placeholder="Select organisation"
            tooltipKey="Datalink:organisation"
        >
        </isav-taxonomy-select-input>
        <isav-department-input
            label="7. Departments"
            formControlName="departments"
            [multiple]="true"
            placeholder="Select departments"
            tooltipKey="Datalink:departments"
            [organisationIri]="form.value.organisation"
        >
        </isav-department-input>
        <isav-taxonomy-select-input
            label="8. Format"
            formControlName="format"
            taxonomy="DatalinkFormat"
            [mandatory]="true"
            placeholder="Select format"
            tooltipKey="Datalink:format"
        >
        </isav-taxonomy-select-input>
        <isav-text-input
            label="9. Keywords"
            formControlName="keywords"
            tooltipKey="Datalink:keywords"
        ></isav-text-input>
        <isav-date-input
            label="10. Start Date"
            formControlName="startDate"
            [mandatory]="true"
            tooltipKey="Datalink:startDate"
        ></isav-date-input>
        <isav-date-input
            label="11. End Date"
            formControlName="endDate"
            [mandatory]="true"
            tooltipKey="Datalink:endDate"
        ></isav-date-input>
        <isav-taxonomy-select-input
            label="12. Theme"
            formControlName="theme"
            taxonomy="Theme"
            [mandatory]="true"
            placeholder="Select theme"
            tooltipKey="Datalink:theme"
        >
        </isav-taxonomy-select-input>
        <isav-taxonomy-checkbox-list-input
            label="13. Topics"
            taxonomy="Topic"
            formControlName="topics"
            tooltipKey="Datalink:topics"
        ></isav-taxonomy-checkbox-list-input>
        <isav-taxonomy-select-input
            label="14. Country"
            formControlName="country"
            taxonomy="RegisteredCountry"
            [mandatory]="true"
            placeholder="Select country"
            tooltipKey="Datalink:country"
        >
        </isav-taxonomy-select-input>
        <isav-taxonomy-select-input
            label="15. Region"
            formControlName="region"
            taxonomy="Region"
            [mandatory]="true"
            placeholder="Select region"
            tooltipKey="Datalink:region"
        >
        </isav-taxonomy-select-input>
        <isav-coordinates-input
            label="16. Location"
            formControlName="location"
            [mandatory]="true"
            tooltipKey="Datalink:location"
        ></isav-coordinates-input>
        <isav-text-input
            label="17. Contact name"
            formControlName="contactName"
            [mandatory]="true"
            tooltipKey="Datalink:contactName"
        ></isav-text-input>
        <isav-text-input
            label="18. Contact email"
            formControlName="contactEmail"
            [mandatory]="true"
            tooltipKey="Datalink:contactEmail"
        ></isav-text-input>
        <isav-text-input
            label="19. Contact secondary email"
            formControlName="contactSecondaryEmail"
            tooltipKey="Datalink:contactSecondaryEmail"
        ></isav-text-input>
        <isav-text-input
            label="20. Contact phone"
            formControlName="contactPhone"
            [mandatory]="true"
            tooltipKey="Datalink:contactPhone"
        ></isav-text-input>
        <isav-document-input
            label="21. Attachments"
            formControlName="attachments"
            tooltipKey="Datalink:attachments"
            [multiple]="true"
        ></isav-document-input>

        <isav-content-editor
            label="22. Description"
            formControlName="description"
            tooltipKey="Datalink:description"
            property="description"
            [iri]="value['@id']"
        ></isav-content-editor>

        <div class="is-flex is-space-between">
            <isav-go-to-view>Back to view</isav-go-to-view>
            <div class="buttons is-right">
                <ng-content></ng-content>
                <button type="button" isavBtn color="danger" class="ml-2" (click)="onDelete()">
                    Delete
                </button>
                <button
                    *ngIf="value.draft"
                    isavBtn
                    color="primary"
                    type="button"
                    [disabled]="!form.valid"
                    (click)="onPublish()"
                >
                    Publish
                </button>
                <button
                    *ngIf="!value.draft"
                    isavBtn
                    color="danger"
                    type="button"
                    (click)="onUnpublish()"
                >
                    Unpublish
                </button>
                <button
                    type="button"
                    isavBtn
                    color="success"
                    [disabled]="!value.draft && !form.valid"
                    (click)="onSave()"
                >
                    Save
                </button>
            </div>
        </div>
    </form>
</div>
